import { controller, rolesObj, menuSideBar } from './controller'
import { ROUTE_PATH } from '../helpers'
export const sideBarMenuController = () => {
  return {
    asset: (obj, menu) => {
      const { roleSingle, roles } = obj
      if (roles) {
        const systemadmin = controller().filterRole(
          roles,
          res => res.id === rolesObj.systemadmin
        )
        const admin = controller().filterRole(
          roles,
          res => res.id === rolesObj.admin
        )
        const user = controller().filterRole(
          roles,
          res => res.id === rolesObj.user
        )
        const risk = controller().filterRole(
          roles,
          res => res.id === rolesObj.risk
        )
        const purchaser = controller().filterRole(
          roles,
          res => res.id === rolesObj.purchaser
        )
        const tec = controller().filterRole(
          roles,
          res => res.id === rolesObj.tec
        )
        const approver = controller().filterRole(
          roles,
          res => res.id === rolesObj.approver
        )
        const observer = controller().filterRole(
          roles,
          res => res.id === rolesObj.observer
        )
        let menuSortResult = []
        if (roleSingle) {
          if (systemadmin.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.companyProfile)
                menuSortResult[1] = value
              if (value.name === menuSideBar.userManagement)
                menuSortResult[2] = value
              if (value.name === menuSideBar.supplierManagement)
                menuSortResult[3] = value
              if (value.name === menuSideBar.supplierDiscovery)
                menuSortResult[4] = value
              if (value.name === menuSideBar.riskManagement)
                menuSortResult[5] = value
              // if (value.name === menuSideBar.sustainabilityManagement)
              //   menuSortResult[6] = value
              // if (value.name === menuSideBar.comprehensiveAssessmentManagement)
              //   menuSortResult[7] = value
              if (value.name === menuSideBar.Sourcing) menuSortResult[6] = value
            })
          } else if (admin.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.companyProfile)
                menuSortResult[1] = value
              if (value.name === menuSideBar.userManagement)
                menuSortResult[2] = value
              if (value.name === menuSideBar.supplierManagement)
                menuSortResult[3] = value
              if (value.name === menuSideBar.supplierDiscovery)
                menuSortResult[4] = value
              if (value.name === menuSideBar.riskManagement)
                menuSortResult[5] = value
              // if (value.name === menuSideBar.complianceManagement)
              //   menuSortResult[5] = value
              // if (value.name === menuSideBar.sustainabilityManagement)
              //   menuSortResult[6] = value
              // if (value.name === menuSideBar.comprehensiveAssessmentManagement)
              //   menuSortResult[7] = value
              if (value.name === menuSideBar.Sourcing) menuSortResult[6] = value
            })
          } else if (user.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.supplierDiscovery)
                menuSortResult[1] = value
            })
          } else if (risk.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.supplierManagement)
                menuSortResult[1] = value
              if (value.name === menuSideBar.supplierDiscovery)
                menuSortResult[2] = value
              if (value.name === menuSideBar.riskManagement)
                menuSortResult[3] = value
              // if (value.name === menuSideBar.sustainabilityManagement)
              //   menuSortResult[4] = value
              // if (value.name === menuSideBar.comprehensiveAssessmentManagement)
              //   menuSortResult[5] = value
            })
          } else if (purchaser.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.supplierManagement)
                menuSortResult[1] = value
              if (value.name === menuSideBar.supplierDiscovery)
                menuSortResult[2] = value
              if (value.name === menuSideBar.Sourcing) menuSortResult[3] = value
            })
          } else if (tec.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.Sourcing) menuSortResult[1] = value
            })
          } else if (approver.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.supplierDiscovery)
                menuSortResult[1] = value
              if (value.name === menuSideBar.Sourcing) menuSortResult[2] = value
            })
          } else if (observer.length !== 0) {
            menu.map((value, index) => {
              if (value.name === menuSideBar.home) menuSortResult[0] = value
              if (value.name === menuSideBar.Sourcing) menuSortResult[1] = value
            })
          }
        } else {
          if (
            user.length !== 0 ||
            risk.length !== 0 ||
            purchaser.length !== 0 ||
            tec.length !== 0 ||
            approver.length !== 0 ||
            observer.length !== 0
          ) {
            menu.map((value, index) => {
              if (
                user.length !== 0 ||
                risk.length !== 0 ||
                purchaser.length !== 0 ||
                tec.length !== 0 ||
                approver.length !== 0 ||
                observer.length !== 0
              ) {
                if (value.name === menuSideBar.home) menuSortResult[0] = value
              }
              if (
                user.length !== 0 ||
                risk.length !== 0 ||
                purchaser.length !== 0 ||
                approver.length !== 0
              ) {
                if (value.name === menuSideBar.supplierDiscovery)
                  menuSortResult[2] = value
              }
              if (risk.length !== 0 || purchaser.length !== 0) {
                if (value.name === menuSideBar.supplierManagement)
                  menuSortResult[1] = value
              }
              if (risk.length !== 0) {
                if (value.name === menuSideBar.riskManagement)
                  menuSortResult[3] = value
              }
              if (risk.length !== 0) {
                if (value.name === menuSideBar.sustainabilityManagement)
                  menuSortResult[4] = value
              }
              if (risk.length !== 0) {
                if (
                  value.name === menuSideBar.comprehensiveAssessmentManagement
                )
                  menuSortResult[5] = value
              }
              if (
                purchaser.length !== 0 ||
                tec.length !== 0 ||
                approver.length !== 0 ||
                observer.length !== 0
              ) {
                if (value.name === menuSideBar.Sourcing)
                  menuSortResult[6] = value
              }
            })
          }
        }
        return menuSortResult
      }
    },
  }
}
